var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16469 10.295C9.11813 10.2563 9.08118 10.2103 9.05598 10.1597C9.03077 10.1091 9.0178 10.0548 9.0178 10C9.0178 9.94521 9.03077 9.89094 9.05598 9.84032C9.08118 9.7897 9.11813 9.74372 9.16469 9.70501L13.7507 5.88418C14.0321 5.6498 14.1902 5.33186 14.1903 5.00031C14.1904 4.66876 14.0324 4.35076 13.7512 4.11626C13.4699 3.88177 13.0884 3.74999 12.6905 3.74991C12.2927 3.74983 11.9111 3.88146 11.6297 4.11585L7.04369 7.93751C6.38846 8.48504 6.02051 9.22675 6.02051 10C6.02051 10.7733 6.38846 11.515 7.04369 12.0625L11.6297 15.8842C11.9111 16.1186 12.2927 16.2502 12.6905 16.2501C13.0884 16.25 13.4699 16.1183 13.7512 15.8838C14.0324 15.6493 14.1904 15.3313 14.1903 14.9997C14.1902 14.6682 14.0321 14.3502 13.7507 14.1158L9.16469 10.295Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.14eb3af5a15043873ee53b0255b335d1.svg";
export { ForwardRef as ReactComponent };